/* eslint-disable @typescript-eslint/naming-convention */
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { environment } from '../../environments/environment';

export const initializeNewRelic = (): void => {
    if (!environment.newRelic) {
        return;
    }

    const config = environment.newRelic;

    new BrowserAgent({
        init: {
            privacy: { cookies_enabled: true },
            ajax: { deny_list: ['bam.nr-data.net'] }
        },
        info: {
            beacon: 'bam.nr-data.net',
            errorBeacon: 'bam.nr-data.net',
            licenseKey: config.licenseKey,
            applicationID: config.applicationID,
            sa: 1
        },
        loader_config: {
            accountID: config.accountID,
            trustKey: config.trustKey,
            agentID: config.applicationID,
            licenseKey: config.licenseKey,
            applicationID: config.applicationID
        }
    });
};
